/**
 *
 * A function to add class to elements in view
 *
 *
 */
export function inViewClass(flag) {
    function isScrolledIntoView(elem) {
        const rect = elem.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const partElem = elem.offsetHeight / 2;
        
        return (
            rect.top + partElem <= windowHeight || 
            rect.bottom - partElem <= windowHeight
        );
    }

    // Check if any infographics are in view on the page
    document.querySelectorAll('.c-infographic').forEach(infographic => {
        // If infographic not in view exit
        if (!isScrolledIntoView(infographic)) return;

        // Add in view class
        if (!infographic.classList.contains('in-view')) {
            infographic.classList.add('in-view');
        }

        // Grab number counter number from data attribute
        const odometer = infographic.querySelector('.odometer');
        if (!odometer) return;
        
        const number = odometer.getAttribute('data_number');
        if (!number) return;

        // If flag = init then this was in view before scroll
        if (flag === 'init') {
            setTimeout(() => {
                odometer.textContent = number;
            }, 1000);
        } else {
            odometer.textContent = number;
        }
    });
}

export function viewsInit() {
    inViewClass('init');
    window.addEventListener('scroll', () => inViewClass());
}
